import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

export interface XmlCompraItemBusca {
    chave: string;
    numNf: string;
}

export interface XmlCompraNota {
    nfeId: number;
    numNota: string;
    serie: string;
    chave: string;
    dataEmissao: string | null;
    total: number | null;
    status: string;
    empresa: number | null;
    fornecedor: string;
    temXml: boolean;
}

export interface XmlCompraBuscaResposta {
    sucesso: boolean;
    notas: XmlCompraNota[];
    naoEncontrados: XmlCompraItemBusca[];
}

/** Tela "Download de XML de Compra" (menu Fiscal) -- notas de entrada do Aerosys. */
@Injectable({providedIn: 'root'})
export class DownloadXmlCompraService {
    private readonly base = '/api/sankhya/fiscal/xml-compra';

    constructor(private readonly http: HttpClient) {}

    buscar(itens: XmlCompraItemBusca[]): Observable<XmlCompraBuscaResposta> {
        return this.http.post<XmlCompraBuscaResposta>(`${this.base}/buscar`, {itens});
    }

    /** Conteudo do XML (texto) -- usado para baixar e para o "Testar XML". */
    xml(nfeId: number): Observable<Blob> {
        return this.http.get(`${this.base}/${nfeId}/xml`, {responseType: 'blob'});
    }

    zip(ids: number[], separarPorMes: boolean): Observable<Blob> {
        return this.http.post(`${this.base}/zip`, {ids, separarPorMes}, {responseType: 'blob'});
    }
}
